import { useMutation } from '@tanstack/react-query';
import { useAuthorizedAxios } from '../../../core/hooks';
import { patchL3ServiceLocation } from '../../api';

export interface L3ServiceGeographicCoordinates {
  itemId: number;
  latitude: number;
  longitude: number;
}

export interface L3ServiceLocationsApiPatchHookResult {
  updateGeographicCoordinates: (l3ServiceGeographicCoordinates: L3ServiceGeographicCoordinates) => void;
}

export const useL3ServiceLocationsApiPatch = (
  customerId: number | null,
) : L3ServiceLocationsApiPatchHookResult => {
  const axios = useAuthorizedAxios();
  const { mutate } = useMutation({
    mutationFn: async (l3ServiceGeographicCoordinates: L3ServiceGeographicCoordinates) => {
      if (customerId === null) {
        console.warn('Cannot update service location, customer is not defined');
      } else {
        await patchL3ServiceLocation(
          axios,
          customerId,
          l3ServiceGeographicCoordinates.itemId,
          {
            coordinates: {
              latitude: l3ServiceGeographicCoordinates.latitude,
              longitude: l3ServiceGeographicCoordinates.longitude
            }
          });
      }
    },
  });
  return {
    updateGeographicCoordinates: (l3ServiceGeographicCoordinates: L3ServiceGeographicCoordinates) => {
      mutate(l3ServiceGeographicCoordinates);
    }
  };
};